<script setup>
import { Head } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import PublicLayout from '@/Layouts/PublicLayout.vue'

defineOptions({ layout: PublicLayout })

const { t } = useI18n()
</script>

<template>
  <Head><title>{{ t('public.thanks.head_title') }}</title></Head>
  <section class="page">
    <h1 class="page__title">{{ t('public.thanks.title') }}</h1>
    <p class="page__lede">{{ t('public.thanks.lede') }}</p>
    <a href="/" class="page__cta">{{ t('public.thanks.cta_home') }}</a>
  </section>
</template>

<style scoped>
.page { max-width: 32rem; margin: 0 auto; padding: 4rem 1.5rem; text-align: center; }
.page__title { font-family: var(--font-display, var(--display)); font-size: 2rem; margin: 0 0 0.5rem; color: var(--ink); font-weight: 700; }
.page__lede  { color: var(--inkSoft); margin: 0 0 2rem; }
.page__cta   { display: inline-block; padding: 0.65rem 1.25rem; border-radius: 0.625rem; background: var(--accent); color: var(--accentInk); text-decoration: none; font-weight: 600; }
</style>
